export const create = {
  createSuccessfully: '新しい洗剤の履歴を正常に作成しました！',
}
